import {
  action,
  observable,
} from 'mobx';
import { getI18n } from 'react-i18next';

class NotifierStore {
  @observable notifications: any[] = [];

  @action
  enqueueSnackbar(note: any): void {
    this.notifications.push({
      key: new Date().getTime() + Math.random(),
      ...note,
    });
  }

  @action
  showSnackbar (message: string|any, options: any = {}): void {
    const note = {
      options: {
        preventDuplicate: true,
        variant: 'warning',
        autoHideDuration: 3000,
        ...options,
      },
      message: getI18n().t(typeof message === 'string' ? message : message.key, typeof message === 'string' ? null : message.props),
    };

    this.enqueueSnackbar(note);
  }

  @action
  showError (message: string|any, delay: number = 5000, options: any = {}): void {
    this.showSnackbar(message, { variant: 'error', autoHideDuration: delay, ...options });
  }

  @action
  showWarning (message: string|any, delay: number = 4000, options: any = {}): void {
    this.showSnackbar(message, { variant: 'warning', autoHideDuration: delay, ...options });
  }

  @action
  showInfo (message: string|any, delay: number = 3000, options: any = {}): void {
    this.showSnackbar(message, { variant: 'info', autoHideDuration: delay, ...options });
  }

  @action
  showSuccess (message: string|any, delay: number = 4000, options: any = {}): void {
    this.showSnackbar(message, { variant: 'success', autoHideDuration: delay, ...options });
  }

  @action
  removeSnackbar (key: any) {
    this.notifications = this.notifications.filter(v => v.key !== key);
  }
}

export default NotifierStore;
